/** Component for Models Functionalities

  //Testing Dynamic import of component relies on /snippets/theme-options.liquid to expose assets url
  (async () => {
      const { default:media } = await import(theme.components.mediaURL);
        media.showConsole();
  })();
 */
  var models = {

    instModelsViewerCarousel:null,
    instMainProductZoom:null,
    init:function(){

        

        $(document).on("change",".model-viewer .model-input-view",function(e){
            if($(this).prop("checked")){
                models.saveModelView("1")
            }else{
                models.saveModelView("0")
            }
            models.updateModelControls();
        })
        


        

        $(document).on("click",".model-viewer .model-change",function(e){
            e.preventDefault();
            
            var getModelId = models.getModel();
            
            if(getModelId=="0" || getModelId==""){
                return false;
            }else{

                if($(this).hasClass("hidemodellist")){
                    $(this).removeClass("hidemodellist").addClass("showmodellist")
                    $(".model-viewer-selection").removeClass("hide")
                    //We hide any element on the page with the attribute data-model-hide
                    //see collection-filters.liquid
                    $("div[data-model-hide='true']").addClass("hide")
                    
                    if(models.instModelsViewerCarousel == null){
                        (async () => {
                            const { carousel } = await import(theme.components.commonURL);
                            models.instModelsViewerCarousel = new carousel();
                            models.instModelsViewerCarousel.init('.model-viewer-selection');
                        })();
                    }
                }else{
                    $(this).removeClass("showmodellist").addClass("hidemodellist")
                    $(".model-viewer-selection").addClass("hide")
                }


            }


            /*if($(this).hasClass("hidemodellist")){
                $(this).removeClass("hidemodellist").addClass("showmodellist")
                $(".model-viewer-selection").removeClass("hide")
                //We hide any element on the page with the attribute data-model-hide
                //see collection-filters.liquid
                $("div[data-model-hide='true']").addClass("hide")
                
                if(models.instModelsViewerCarousel == null){
                    (async () => {
                        const { carousel } = await import(theme.components.commonURL);
                        models.instModelsViewerCarousel = new carousel();
                        models.instModelsViewerCarousel.init('.model-viewer-selection');
                    })();
                }
            }else{
                $(this).removeClass("showmodellist").addClass("hidemodellist")
                $(".model-viewer-selection").addClass("hide")
            }*/
            
        })




        $(document).on("click",".model-viewer-selection .model",function(e){
            e.preventDefault();
            var getDataModelID = $(this).attr("data-model-id")
            models.saveModel(getDataModelID)
            models.setSelectedModel();

            //$(".model-viewer .model-selected-name").html(models.getModelInfo().name)
            models.displaySelectedModelInfo();

            $(".model-viewer-selection").addClass("hide")
            $(".model-viewer .model-change").removeClass("showmodellist").addClass("hidemodellist")
            $(".model-viewer .model-select").addClass("hide")
            $(".model-viewer .model-selected").removeClass("hide")
            models.updateModelsDisplay(".product-media");
        })



        /* $(document).on("click",".model-viewer .model-change",function(e){
            e.preventDefault();
            console.log("clicked")
            if($(this).hasClass("hidemodellist")){
                $(this).removeClass("hidemodellist").addClass("showmodellist")
                $(".model-viewer-selection").removeClass("hide")
                //We hide any element on the page with the attribute data-model-hide
                //see collection-filters.liquid
                $("div[data-model-hide='true']").addClass("hide")
                
                if(models.instModelsViewerCarousel == null){
                    (async () => {
                        const { carousel } = await import(theme.components.commonURL);
                        models.instModelsViewerCarousel = new carousel();
                        models.instModelsViewerCarousel.init('.model-viewer-selection');
                    })();
                }
            }else{
                $(this).removeClass("showmodellist").addClass("hidemodellist")
                $(".model-viewer-selection").addClass("hide")
            }
            
        })




       $(document).on("change",".model-viewer .model-input-view",function(e){
            if(!$(this).prop("checked")){
                models.saveModel("0")
                
                $(".model-viewer-selection").addClass("hide")
                $(".model-viewer .model-change").removeClass("showmodellist").addClass("hidemodellist")
                $(".model-viewer .model-selected").addClass("hide")
                $(".model-viewer .model-selected-name").html("")
                $(".model-viewer .model-selected-info").html("").addClass("hide")
                $(".model-viewer .model-selected-heading").addClass("hide")
                $(".model-viewer-selection a.model").removeClass("sel")
                $(".model-viewer .model-change").addClass("hide");
                $(".model-viewer .model-select").addClass("hide")

                models.updateModelsDisplay(".product-media")
            }else{
                var getModelId = models.getModel();
                $(".model-viewer .model-change").removeClass("hide")
                if(getModelId == "0"){
                    $(".model-viewer .model-select").removeClass("hide")
                    $(".model-viewer .model-selected").addClass("hide")
                    $(".model-viewer .model-selected-name").html("")
                    $(".model-viewer .model-selected-info").html("").addClass("hide")
                    $(".model-viewer .model-selected-heading").addClass("hide")
                }else{
                    $(".model-viewer .model-select").addClass("hide")
                    $(".model-viewer .model-selected").removeClass("hide")
                    models.displaySelectedModelInfo();
                    

                }
            }
        })
        

        $(document).on("click",".model-viewer .model-change",function(e){
            e.preventDefault();
            console.log("clicked")
            if($(this).hasClass("hidemodellist")){
                $(this).removeClass("hidemodellist").addClass("showmodellist")
                $(".model-viewer-selection").removeClass("hide")
                //We hide any element on the page with the attribute data-model-hide
                //see collection-filters.liquid
                $("div[data-model-hide='true']").addClass("hide")
                
                if(models.instModelsViewerCarousel == null){
                    (async () => {
                        const { carousel } = await import(theme.components.commonURL);
                        models.instModelsViewerCarousel = new carousel();
                        models.instModelsViewerCarousel.init('.model-viewer-selection');
                    })();
                }
            }else{
                $(this).removeClass("showmodellist").addClass("hidemodellist")
                $(".model-viewer-selection").addClass("hide")
            }
            
        })


        $(document).on("click",".model-viewer-selection .model",function(e){
            e.preventDefault();
            var getDataModelID = $(this).attr("data-model-id")
            models.saveModel(getDataModelID)
            models.setSelectedModel();

            //$(".model-viewer .model-selected-name").html(models.getModelInfo().name)
            models.displaySelectedModelInfo();

            $(".model-viewer-selection").addClass("hide")
            $(".model-viewer .model-change").removeClass("showmodellist").addClass("hidemodellist")
            $(".model-viewer .model-select").addClass("hide")
            $(".model-viewer .model-selected").removeClass("hide")
            models.updateModelsDisplay(".product-media");
        })*/
        
        $(document).on("click","#closemobileviewer",function(e){
            e.preventDefault();
            models.closeMobileViewer();
        })



       

        models.repositionModels();
        models.setSelectedModel()

        var getModelView = models.getModelView();
        $(".model-viewer .model-input-view").prop("checked",(getModelView=="1"?true:false))

        models.updateModelControls();
        //Detect selected model an update any UI elements
        /*var getModelId = this.getModel();
        if(getModelId!==""){
            
            if(getModelId!=="0"){
                $(".model-viewer .model-input-view").prop("checked",(getModelId=="0"?false:true)).trigger("change")
            }else{
                if($(".model-viewer").hasClass("hideproductview")){
                    $(".model-viewer .model-select").removeClass("hide")
                }
            }

            models.repositionModels();

         

            models.setSelectedModel()
            models.updateModelsDisplay(".product-media")
        }*/
        //models.updateModelsDisplay(".product-media")
    },
    updateModelControls:function(){
        
        var getModelView = models.getModelView();
        var getModelId = models.getModel();

        /*if(getModelView == "" ){
            models.saveModelView("0")
            getModelView = this.getModelView();
        }*/
        
       // $(".model-viewer .model-input-view").prop("checked",(getModelView=="1"?true:false))

       $(".model-viewer .model-selected-name").html("")
       $(".model-viewer .model-selected-info").html("").addClass("hide")
       $(".model-viewer .model-selected-heading").addClass("hide")
       $(".model-viewer .model-selected").addClass("hide")

        if(getModelView == "1"){
            $(".model-viewer .model-change").removeClass("hide")   

            if(getModelId=="0" || getModelId==""){
                $(".model-viewer .model-select").removeClass("hide")
                $(".model-viewer-selection").removeClass("hide")
                
            }else{
                $(".model-viewer-selection").addClass("hide")
                $(".model-viewer .model-change").removeClass("showmodellist").addClass("hidemodellist")
                $(".model-viewer .model-select").addClass("hide")
                $(".model-viewer .model-selected").removeClass("hide")
                models.displaySelectedModelInfo();
            }

        }else{ 
            $(".model-viewer .model-change").addClass("hide")   
            $(".model-viewer .model-select").addClass("hide")
            $(".model-viewer-selection").addClass("hide")
        }
        models.updateModelsDisplay(".product-media");
    },
    repositionModels:function(){
        //leveraging JS code to reorder models instead of using liquid
        for(var i=1;i<=5;i++){
            var getModelPositionElement = $(".model-viewer-selection a.model[data-model-position='" + i + "']")
            
            if(getModelPositionElement.length > 0){
                getModelPositionElement.parent().appendTo($(".model-viewer .models-list-wrap"))
            }
        }
    },

    displaySelectedModelInfo:function(){
        $(".model-viewer .model-selected-name").html(models.getModelInfo().name)
        $(".model-viewer .model-selected-info").html(models.getModelInfo().description).removeClass("hide")
        $(".model-viewer .model-selected-heading").removeClass("hide")
    },

    updateQuickViewModelsDisplay:function(){
        var getModelId = this.getModel();
        var getModelView = models.getModelView();
        
        if(getModelView == ""){
            getModelId = "0"
        }

        if(getModelId!==""){
            models.updateModelsDisplay("#quickview-product-template .product-media",getModelId)
        }
    },
    updateModelsDisplay:function(elems){

        var getModelId = this.getModel();
        var getModelView = models.getModelView();
        
        if(getModelView == "" || getModelView == "0"){
            getModelId = "0"
        }
        
        //console.log(elems)
        $(elems).each(function(ind){
            var jsonModels = $(this).attr("data-models");
            var isMain = false;
            var productTitle = $(this).attr("data-title")
            var hasVideo = false;
            var videoData = $(this).attr("data-video"); 
            var videoRef = $(this).attr("data-video");
            var isBynder = true;
            var isTouchScreen = (('ontouchstart' in window) ||    (navigator.maxTouchPoints > 0) ||            (navigator.msMaxTouchPoints > 0));
            
            if(!$(this).hasClass("bynder")){
              isBynder = false;
            }
            
            if($(this).hasClass("main")){
                var iWidth  = '869';
                var iHeight = '944'//'965';
                isMain = true
            }else{ //card
                var iWidth  = '491';
                var iHeight = '534';
            }


            var ithWidth = '85';
            var ithHeight = '94';

            if($(this).hasClass("hasVideo")){
                hasVideo = true;
            }
            
            if(jsonModels!==""){
                jsonModels  = JSON.parse(jsonModels);
              //jsonModels = jsonModels[0];

                var mapViewsArray = jsonModels.map((el)=>el.views);

                if(!$(this).hasClass("bynder")){
                var flatMapViews =  mapViewsArray[0];  //mapViewsArray.flat(); 
                }else{
                var flatMapViews =  mapViewsArray.flat(); 
                }
       
                var getViews = flatMapViews; //jsonModels[0].views; //default views

                if(!$(this).hasClass("main") && !$(this).hasClass("bynder")){
                    if(getViews.length > 1){
                      const temp = getViews[0];
                      getViews[0] = getViews[1];
                      getViews[1] = temp;
                      
                    }
                }


                //We are not displaying models for now, so 
                //we are grouping all views
                /*for(var i=0;i<jsonModels.length;i++){
                    if(jsonModels[i].id == getModelId){
                        getViews = jsonModels[i].views;
                        break;
                    }
                }*/
                
                //Update Image pointers
                var htmlSliders = "";
                var htmlThumbSliders = "";

                var totalViews = getViews.length;

                if(!isMain){
                    totalViews = 2;
                }

                for(var j=0;j<totalViews;j++){


                        if(typeof(getViews[j])=="undefined"){
                            break;
                        }

                        htmlSliders +=  '<div class="media-slide">' 
                        htmlThumbSliders += '<div class="thumb-media-slide' + (j==0?" slide-sel":"")   + '">' 
                        if(j==0){
                            htmlSliders +=  "<img " + "alt='" + productTitle + "' " + (isMain?" ":"loading='lazy' ") +"width='" +iWidth +"' height='" +iHeight + "' src='" + getViews[j] + (isBynder?
                              ("?io=transform:extend,background:white,width:" + iWidth + ",height:" + iHeight)
                              : "&width=" + iWidth
                            )
                        }else{

                            if(!isMain){
                                htmlSliders +=  "<img " + "alt='" + productTitle + "' " + (isMain?" ":"loading='lazy' ") +"width='" +iWidth +"' height='" +iHeight + "' src='" + getViews[j] + (isBynder?
                                      ("?io=transform:extend,background:white,width:" + iWidth + ",height:" + iHeight)
                                      : "&width=" + iWidth
                                    )
                            }else{
                                htmlSliders +=  "<img " + "alt='" + productTitle + "' "  + " loading='lazy' width='" +iWidth +"' height='" +iHeight + "' src='data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==' data-src='" + getViews[j] + (isBynder?
                                  ("?io=transform:extend,background:white,width:" + iWidth + ",height:" + iHeight)
                                  : "&width=" + iWidth
                                )
                            }
                           
                        }

                        htmlThumbSliders +=  "<img " + "alt='" + productTitle + "' "  +"width='" +ithWidth +"' height='" +ithHeight + "' src='" + getViews[j] + (isBynder?
                          ("?io=transform:extend,background:white,width:" + ithWidth + ",height:" + ithHeight)
                          : "&width=" + ithWidth
                        )
                        htmlThumbSliders +=  "'" 
                        
                        htmlSliders +=  "'" 
                        if(isMain){
                            //add additional properties for zoom functionality on Main Image Only
                            htmlSliders += " class='nszoomer' "
                            htmlSliders += " preloader='"+ theme.loaderImage + "' "
                            htmlSliders += " big='" +  getViews[j]  + "?io=transform:extend,background:white,width:1200,height:1304" + "' "
                            htmlSliders += " placeholder='" + theme.components.spacerURL + "' "

                        }
                        htmlSliders +=  "/>" 
                        htmlSliders +=  "</div>"

                        htmlThumbSliders +=  "/>" 
                        htmlThumbSliders +=  "</div>"
                }

                if(hasVideo){

                    var jsonVideoData = JSON.parse(videoData)
                    var videoObject = jsonVideoData.videos?jsonVideoData.videos:jsonVideoData.video

                    if(videoObject){

                        for(var i=0;i<videoObject.length;i++){

                            var videoReference = jsonVideoData.videos?videoObject[i].src:videoObject[i]
                            var videoThumb = jsonVideoData.videos?videoObject[i].thumb:null
                            var typeVideoClass = " vmv";
                            if(videoReference.indexOf("https:")!==-1){
                                typeVideoClass = " ytv"
                            }

                            if(isBynder){
                            htmlSliders +=  '<div class="media-slide media-slide-video">' 
                            htmlSliders +=      "<div class='media-video-wrap" + typeVideoClass +"' data-video-ref='" + videoReference + "'>"
                            htmlSliders +=         "<img width='" +iWidth +"' height='" +iHeight + "' src='"+theme.components.videoImg+"' />" 
                            htmlSliders +=      "</div>"
                            htmlSliders +=  "</div>"


                            htmlThumbSliders +=  '<div class="thumb-media-slide thumb-media-slide-video">' 
                            htmlThumbSliders +=      "<div class='media-video-wrap" + typeVideoClass +"' data-video-ref='" + videoReference + "'>"
                            htmlThumbSliders +=         "<img width='" +ithWidth +"' height='" +ithHeight + "' src='"+(videoThumb?videoThumb:theme.components.videoImg)+"' />" 
                            htmlThumbSliders +=      "</div>"
                            htmlThumbSliders +=  "</div>"

                        }else{

                            htmlSliders +=  '<div class="media-slide media-slide-video">' 
                            htmlSliders +=      "<div class='media-video-wrap" + typeVideoClass +"' data-video-ref='" + videoReference + "'>"
                            htmlSliders +=         "<img width='" +iWidth +"' height='" +iHeight + "' src='data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==' />" 
                            htmlSliders +=      "</div>"
                            htmlSliders +=  "</div>"


                            htmlThumbSliders +=  '<div class="thumb-media-slide thumb-media-slide-video">' 
                            htmlThumbSliders +=      "<div class='media-video-wrap" + typeVideoClass +"' data-video-ref='" + videoReference + "'>"
                            htmlThumbSliders +=         "<img width='" +ithWidth +"' height='" +ithHeight + "' src='data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==' />" 
                            htmlThumbSliders +=      "</div>"
                            htmlThumbSliders +=  "</div>"
                        }
    
                        }
                    }
                    

                    
                }
                
                if(htmlSliders!=""){
                    var elem  = $(this).find(".product-image-slideshow")
                    var elemParent = elem.parent();
                    
                    var elemThumb = elemParent.parent().find(".thumbnails-image-slideshow")
    
                    if(elem.find(".cycle-slide").length > 0){

                        elem.cycle('destroy');
                        elem.remove();
                        elemParent.prepend('<div class="product-image-slideshow" data-allow-wrap="false" data-cycle-swipe="true" data-cycle-slides="> div.media-slide" data-cycle-fx="scrollHorz" data-cycle-log="false" data-cycle-timeout="0" data-cycle-carousel-visible="1"  data-cycle-next="~ .image-navigation .next" data-cycle-prev="~ .image-navigation .prev">' + 
                        '<img loading="lazy" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" border="0"  width="' + iWidth + '" height="' + iHeight + '" /></div>')

                        elem  = $(this).find(".product-image-slideshow")
                        elem.html(htmlSliders);

                    }else{
                        elem.html(htmlSliders);
                    }

                    if(htmlThumbSliders!=="" ){

                       if (elemThumb.length >0){
                            elemThumb.html(htmlThumbSliders)
                       }
                            
                       
                    }
                    
               
                    //on non desktop we want the slider to be swiped
                    if(!isMain){
                        if($("#mobile-menu").is(":visible")){

                            elem.attr("data-cycle-next","~ .image-navigation .next")
                            elem.attr("data-cycle-prev","~ .image-navigation .prev")
                            elem.attr("data-cycle-timeout","0")
                            elem.attr("data-cycle-fx","scrollHorz")
                            elem.attr("data-allow-wrap","true")
                      
                        }
                    }
                   


               
                    //need to be defined before calling cycle();
                    elem.on( 'cycle-post-initialize', function( event, opts ) {
                        
                        if(elemParent.parent().hasClass("main")){
                            console.log(elemParent[0])    
                            
                            if(elem.find(".cycle-slide-active img.nszoomer").length > 0){
                            
                                (async () => {
                                     const { checkLibrary } = await import(theme.components.commonURL);
                         
                                        checkLibrary($.Zoomer,theme.components.zoomLibraryURL, function(){
                                            models.activateZoom(elem.find(".cycle-slide-active img.nszoomer"));
                                        })
                                        
                                 })();
     
                             }

                             if(elem.parent().parent().hasClass("main") && elems.indexOf("#quickview-product-template")==-1 ){
                                 console.log(typeof(ScrollBalance))
                                 if(typeof(ScrollBalance)=='function'){
                                     console.log("on load scroller")
                                     setTimeout(function(){

                                        if($('#main_product .scroller').length > 0){
                                            var sb = new ScrollBalance($('#main_product .scroller'),{
                                                minwidth: 1024,
                                                fixedElementHeight:$("#header-wrapper").length>0?($("#header-wrapper").height()+10):0 //10 extra padding
                                            });
                                            sb.bind();
                                            sb.initialize();
                                            $(window).trigger("resize")
                                        }
                                        
                                     },500)
                                     
                     
                                 }
                             }
                             
                           
                        }
                     
                    });

                      elem.cycle();

                      if(!isMain){
                        elem.cycle('pause');
                      }
                      
                    /*elem.on( 'cycle-pager-activated', function( event, opts ) {

                        console.log("activated")
                        
                        models.loadMedia(elem,event, opts);
                    });*/
                    
                   


                        elem.on( 'cycle-next', function( event, opts ) {
                        

                            if (elemThumb.length >0){
                                elemThumb.find(".thumb-media-slide").removeClass("slide-sel")
                                elemThumb.find(".thumb-media-slide").eq(opts.currSlide).addClass("slide-sel")

                                if(elemThumb.parent().hasClass("horizontal")){
                                    elemThumb.parent().animate({
                                        scrollLeft: elemThumb.find(".slide-sel").offset().left
                                    }, 300,function(){
                                        //complete scrolling
                                    });
                                }else{
                                    elemThumb.parent().animate({
                                        scrollTop: elemThumb.find(".slide-sel").offset().top
                                    }, 300,function(){
                                        //complete scrolling
                                    });
                                }
                            }

                            models.loadMedia(elem,event, opts);
                        });
                        elem.on( 'cycle-prev', function( event, opts ) {

                            if (elemThumb.length >0){
                                elemThumb.find(".thumb-media-slide").removeClass("slide-sel")
                                elemThumb.find(".thumb-media-slide").eq(opts.currSlide).addClass("slide-sel")
                
                                if(elemThumb.parent().hasClass("horizontal")){
                                    elemThumb.parent().animate({
                                        scrollLeft: elemThumb.find(".slide-sel").offset().left
                                    }, 300,function(){
                                        //complete scrolling
                                    });
                                }else{
                                    elemThumb.parent().animate({
                                        scrollTop: elemThumb.find(".slide-sel").offset().top
                                    }, 300,function(){
                                        //complete scrolling
                                    });
                                }
                            }
                            
                            models.loadMedia(elem,event, opts);
                        });

                        if(!isMain){

                            if(!isTouchScreen){
                                elem.hover(
                                    function(e){
                                        elem.cycle('next');
                                    },
                                    function(e){
                                        elem.cycle('prev');
                                    }
                                  )
                            }
                        }
                
                   

                }    
            }
        })
    },
    activateZoom:function(imgElem){

        if(models.instMainProductZoom!==null){
            models.instMainProductZoom = null;
        }

        models.instMainProductZoom = new $.Zoomer({
            element:imgElem,
                zoomwidth:1200,
                zoomheight:1304,//1333,
                alttext:imgElem.attr("alt"),
                usetouch:!$("#viewport").is(":visible")?true:false,
                ontouch:function(elem){
                    $(elem).off("click")
                    $(elem).on("click",function(){
                        models.showMobileViewer($(this));
                    })
                    
                },
                onzoom:function(){
                }
        })

    },
    showMobileViewer:function(elem){

        var zoomimage = elem.attr("big")
        $(document.body).addClass("mobilezoomactive")
        if($("#mobileimageviewer").length <=0 ){
      $(document.body).append("<div class='mobile' id='taptozoomout'>" + 
                      '<div class="hover-msg hide">'  + 
                        '<div class="hover-wrap mobile">' + 
                          '<span class="img">' + 
                            '<span class="mobile">' + 
                              '<span class="fa fa-search-minus"></span>' + 
                              ' Tap on the image to zoom out' + 
                            '</span>'  + '</span></div></div>'+
      
                      "</div>" + 
                      "<div id='mobileimageviewer'><div class='wrap'><a id='closemobileviewer' href='javascript:void(0);'><img src='" +zoomimage +  "'/></a></div></div>")
  
    }else{
      $("#mobileimageviewer .wrap img").attr("src",zoomimage)
    }

        $("#mobileimageviewer").width($(window).width() + "px")
        $("#mobileimageviewer").height($(window).height() + "px")
        $("#mobileimageviewer .wrap").scrollLeft(($("#mobileimageviewer .wrap")[0].scrollWidth-$(window).width())/2)		
        $(window).resize(function()	{
            $("#mobileimageviewer").width($(window).width() + "px")
            $("#mobileimageviewer").height($(window).height() + "px")
        })
    },
    closeMobileViewer:function(){
            $(document.body).removeClass("mobilezoomactive")
            $("#mobileimageviewer").remove();
            $("#taptozoomout").remove();
            $("body,html").scrollTop(0);
        
    },
    loadMedia:function(elem,event,opts){
        


        //Load Image
        var getImgAttrib = elem.find(".cycle-slide-active img").attr("data-src")
        var getVideoAttrib = null;
        
        if(elem.find(".cycle-slide-active .media-video-wrap").length >0){
            getVideoAttrib = elem.find(".cycle-slide-active .media-video-wrap").attr("data-video-ref")
        }

        if (typeof(getImgAttrib)!=='undefined'){
            elem.find(".cycle-slide-active img").attr("src",getImgAttrib)
            elem.find(".cycle-slide-active img").removeAttr("data-src")
        }

        if(elem.find(".cycle-slide-active .nszoomer").length >0){
            if(elem.find(".zoomer-wrapper").length >0){
                elem.find(".zoomer-wrapper .nszoomer").removeClass("imageready")
                elem.find(".zoomer-wrapper").before(elem.find(".zoomer-wrapper .nszoomer"))
                elem.find(".zoomer-wrapper").remove();
            }
            models.activateZoom(elem.find(".cycle-slide-active img.nszoomer"))
                
        }

        
        //Load Video
        if (getVideoAttrib!==null){

            if(getVideoAttrib.indexOf("https:")!==-1){
                
                var htmlVideo = '<iframe width="100%" height="100%" src="' + getVideoAttrib + '" title="" frameborder="0" allow="accelerometer;' +
                                ' autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>'
                elem.find(".cycle-slide-active .media-video-wrap").html(htmlVideo);

            }else{
                if(elem.find(".cycle-slide-active .media-video-wrap .vimeo-space").length <=0){
                    $.ajax({
                        type: 'GET',
                        url:'https://vimeo.com/api/oembed.json?url=' + encodeURI('https://vimeo.com/' + getVideoAttrib),
                        success: function(response) {
                            
        
                            if(response.thumbnail_url!==""){
                                var initialThumbURL = response.thumbnail_url.split("_")[0];
                                
                                var newThumbURL = initialThumbURL + "_86x96" 
        
                                //$(productPageInstance.productContainer + " .product-image-thumbnails li.video a").html("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><g><path class='fa-secondary' fill='currentColor' d='M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z' opacity='0.4'></path><path class='fa-primary' fill='currentColor' d='M371.7 280l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z'></path></g></svg><img alt=" +  response.title + " src='" + newThumbURL + "'>")
                                var appid = '122963'
                                var htmlVideo = "";
                                    htmlVideo += '<div class="vimeo-space"><iframe width="100%" height="100%" src="https://player.vimeo.com/video/' + response.video_id + '?autoplay=0&loop=1&badge=0&autopause=0&player_id=0&app_id=' + 
                                                appid+ '" allow="fullscreen;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div><script src="https://player.vimeo.com/api/player.js"><\/script>'
        
                                elem.find(".cycle-slide-active .media-video-wrap").html(htmlVideo);
                                
                            }
                        
                        },
                        error: function(status) {
                            console.warn( 'ERROR', status );
                        }
                    })    
                }
    
            }


            

        }else{
            //stop Video
            if(elem.find(".vimeo-space iframe").length > 0){
                elem.find(".vimeo-space iframe").attr("src",elem.find(".vimeo-space iframe").attr("src"))
            }
            
            if(elem.find(".youtube-space iframe").length > 0){
                elem.find(".youtube-space iframe").attr("src",elem.find(".youtube-space iframe").attr("src"))
            }
            


        }

      

    },
    setSelectedModel:function(){

        var getModelId = models.getModel()
        $(".model-viewer-selection a.model").removeClass("sel")

        $(".model-viewer-selection a.model").each(function(){
            if($(this).attr("data-model-id") == getModelId){
                $(this).addClass("sel")
                return false;
            }
        })
    },
    getModelInfo:function(info){
        var retValObj = {
            "type":"",
            "description":"",
            "position":"",
            "name":"",
            "id":""
        };
        var getModelId = models.getModel()
        $(".model-viewer-selection a.model").each(function(){
            if($(this).attr("data-model-id") == getModelId){
                retValObj = {
                    "type":$(this).attr("data-model-type"),
                    "description":$(this).attr("data-model-description"),
                    "position":$(this).attr("data-model-position"),
                    "name":$(this).attr("data-model-name"),
                    "id":$(this).attr("data-model-id")
                };
                return false;
            }
        })
        return retValObj;
    },
    saveModel:function(modelId){

        Cookies.set("modelSelection",modelId,365);
    },
    getModel:function(){
        return typeof(Cookies.get("modelSelection"))!=="undefined"?Cookies.get("modelSelection"):"0";
    },
    getModelView:function(){
        return typeof(Cookies.get("modelView"))!=="undefined"?Cookies.get("modelView"):"0";
    },
    saveModelView:function(onoff){ //"0" or 1
        Cookies.set("modelView",onoff,365);
    }

}

export default models;